(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupTypeDetailController', GroupTypeDetailController);

    GroupTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GroupType', 'User'];

    function GroupTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, GroupType, User) {
        var vm = this;

        vm.groupType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:groupTypeUpdate', function(event, result) {
            vm.groupType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
